import MainContent from "../components/MainContent";
import useRequestApproval from "../hook/useRequestApproval";

const RequestApproval = () => {
  const RequestApprovalProps = useRequestApproval();
  return <MainContent {...RequestApprovalProps} />;
};

export default RequestApproval;
